<template>
  <div>
    <search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" :type="false" />
    <van-cell style="padding: 16px 10px;">
      <van-tag size="large" type='primary' @click="clickTag(item.dayType)" v-for="(item,index) in timeOptions" :key="index" color="#F4F5F7"
        text-color="#606060" :class="activeId === item.dayType?'tag-click':'tag-before'">{{item.value}}</van-tag>
      <van-icon style="margin-left: 10px" size="20" name="filter-o" @click="handleFilter()" />
    </van-cell>
    <div class="sectionList">
      <van-grid clickable :column-num="2" style="width: 100%">
        <van-grid-item v-for="(item,index) in gridList" :key="index" @click="toDetail">
          <div class="center">
            <span class="Statistics_num">{{item.count}}</span>
            <span class="Statistics_name">{{item.name}}</span>
          </div>
          <div class="percentage" v-if="activeId != '2021'">
            <van-icon :name="item.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="item.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
            <span :style="item.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{item.float.replace('-','')}}</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="Statistics_title">客户对比分析</div>
    <div id="main"></div>
    <div class="Statistics_title">客户所属行业分析</div>
    <van-tabs v-model="activeTab" @change="tabChange">
      <van-tab title="饼状分析">
        <div id="main2" v-if="activeTab == '0'">
          <van-empty v-if="industryNone" description="暂无客户数据" />
        </div>
      </van-tab>
      <van-tab title="数据Top10排名">
        <tongji-table v-if="tableData.length > 0" :tableData="tableData" :option="option" />
        <van-empty v-else description="暂无客户数据" />
      </van-tab>
    </van-tabs>
    <div class="Statistics_title">客户等级分析</div>
    <div id="main3"></div>
    <div class="Statistics_title">客户来源分析</div>
    <div id="main4">
      <van-empty v-if="sourceNone" description="暂无客户数据" />
    </div>
    <div class="custSource">
      <span>{{custSourceGs.name}}：{{custSourceGs.count}}个    {{custSourceGs.float}}</span>
      <span>{{custSourceGr.name}}：{{custSourceGr.count}}个    {{custSourceGr.float}}</span>
    </div>
    <div class="Statistics_title">客户所属地区分析</div>
    <div id="main5">
      <van-empty v-if="areaNone" description="暂无客户数据" />
    </div>
    <div class="Statistics_title">客户单位性质分析</div>
    <div id="main6">
      <van-empty v-if="unitNone" description="暂无客户数据" />
    </div>
    <div class="Statistics_title">商机阶段数据分析</div>
    <div id="main7"></div>
  </div>
</template>

<script>
import {
  Grid,
  GridItem
  // Image as VanImage
  // Cascader
} from 'vant'
import search from './component/search.vue'
// import { getAllStage } from '@/api/scrm/mycust'
// import { getDicts } from '@/api/system/dict/data'
import statistics from '@/api/tongji/statistics'
import tongjiTable from './component/tongjiTable.vue'
// import { CascaderTreeSelect } from '@/api/admi/dept'
import * as echarts from 'echarts'

// import { listStatistical } from '@/api/tongji/index'
export default {
  name: 'TongjiIndex',
  components: {
    search,
    tongjiTable,
    [Grid.name]: Grid,
    // [VanImage.name]: VanImage,
    [GridItem.name]: GridItem
    // vanCascader: Cascader
  },
  props: {},
  data() {
    return {
      showFilterPop: false,
      // activeNames: ['1'],
      // icon_title: require('../../assets/images/tj/ghicon.png'),
      activeId: '1',
      activeTab: '0',
      queryParams: {
        deptId: null,
        startTime: null,
        endTime: null,
        dayType: '1'
      },
      divisionList: [],
      boSuccessList: [],
      boList: [],
      custList: [],
      businessFunnel: [],
      statisticsArr: [],
      industryNone: false,
      custIndustryList: [],
      custLevlList: [],
      sourceNone: false,
      custSourceList: [],
      custSourceGs: {},
      custSourceGr: {},
      areaNone: false,
      custAreaList: [],
      unitNone: false,
      unitNatureList: [],
      options: {
        boStageIdOptions: [],
        crmCustLevelOptions: []
      },
      tableData: [],
      // th
      option: {
        column: [{
          label: '排名',
          tableDataprop: 'ranking'
        },
        {
          label: '所属行业',
          tableDataprop: 'industry'
        },
        {
          label: '客户数量',
          tableDataprop: 'custSum'
        }]
      },
      // // 合同类型
      // contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // // 合同状态
      // contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // // 产品类型列表
      // businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [], { dayType: '7', value: '近七天' }, { dayType: '15', value: '近15天' },
      timeOptions: [{ dayType: '1', value: '昨天' }, { dayType: '0', value: '今天' }, { dayType: '30', value: '本月' }, { dayType: '180', value: '上半年' }, { dayType: '365', value: '今年' }, { dayType: this.getPreMonth(), value: this.getPreMonth() + '年' }],
      gridList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getStatistics()
  },
  async mounted() {
    this.init()
    await this.getStatisticsByDept()

    await this.getStatisticsByCustIndustry()
    await this.getStatisticsByCustLevel()
    await this.getStatisticsByCustSource()
    await this.getStatisticsByCustArea()
    await this.getStatisticsByCustUnitNature()

    await this.getBusinessFunnel()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = 'scrm-统计'
    },
    /** 获取上一年 */
    getPreMonth() {
      var date = new Date()
      var year = date.getFullYear()
      return parseInt(year) - 1
    },
    // 获取统计数
    async getStatistics() {
      await statistics.getCount(this.queryParams).then(res => {
        if (res.code === 200) {
          this.gridList = res.data
          this.gridList.boSuccses.name = '成交数'
          this.gridList.boSum.name = '商机数'
          this.gridList.custSum.name = '客户数'
          this.gridList.seaSum.name = '公海数'
        }
      })
    },
    // 获取不同部门统计数据
    async getStatisticsByDept() {
      // this.queryParams.deptId = null
      // this.queryParams.isBuss = '1'
      await statistics.getCustCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows.slice(0, 10)
          this.custList = []
          this.divisionList = []
          arr.forEach(item => {
            this.custList.push(item.order)
            if (item.nickName) {
              this.divisionList.push(item.nickName)
            } else {
              this.divisionList.push(item.deptName.replace('事业部', ''))
            }
          })
        }
      })
      await statistics.getBoSuccessCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows.slice(0, 10)
          this.boSuccessList = []
          arr.forEach(item => {
            this.boSuccessList.push(item.order)
          })
        }
      })
      await statistics.getBoCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows.slice(0, 10)
          this.boList = []
          arr.forEach(item => {
            this.boList.push(item.order)
          })
        }
      })
      await this.drawChart()
    },
    // 获取商机阶段数据分析
    async getBusinessFunnel() {
      // const numArr = []
      this.businessFunnel = []
      // if (this.options.boStageIdOptions.length == 0) {
      //   await getAllStage().then(response => {
      //     this.options.boStageIdOptions = response.rows
      //   })
      // }
      await statistics.getFunnelData(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.businessFunnel = []
            this.drawChart7()
          } else {
            arr.forEach(item => {
              this.businessFunnel.push({ name: item.stageName, value: item.custSum, boStageId: item.boStageId })
            })
            this.drawChart7()
          }
          // this.options.boStageIdOptions.forEach(item => {
          //   if (!item.custSum) {
          //     item.custSum = 0
          //   }
          //   if (!arr) {
          //     this.businessFunnel.push({ name: item.stageName, value: 0 })
          //   } else {
          //     arr.forEach(item2 => {
          //       if (item.boStageId == item2.boStageId) {
          //         item.custSum = item2.custSum
          //       }
          //     })
          //     this.businessFunnel.push({ name: item.stageName, value: item.custSum })
          //   }
          //   // numArr.push(item.custSum)
          // })
        }
      })
      // await this.drawChart7()
    },
    tabChange(val) {
      this.getStatisticsByCustIndustry()
    },
    // 所属行业区分
    async getStatisticsByCustIndustry() {
      this.custIndustryList = []
      this.tableData = []
      await statistics.getIndustryData(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.custIndustryList = []
            this.drawChart2('2')
            this.industryNone = true
          } else {
            this.industryNone = false
            arr.forEach(item => {
              this.custIndustryList.push({ name: item.industryName, value: item.custSum, industryCode: item.industryCode })
            })
            arr.slice(0, 10).forEach((item, index) => {
              this.tableData.push({ ranking: index + 1, industry: item.industryName, custSum: item.custSum })
            })
            this.drawChart2('2')
          }
        }
      })
    },
    // 客户来源区分
    async getStatisticsByCustSource() {
      this.custSourceList = []
      await statistics.getCustSourceData(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          this.custSourceGs = res.rows[0].custSourceCompany
          this.custSourceGr = res.rows[0].custSourcePersonal
          if (!arr) {
            this.custSourceList = []
            this.drawChart2('4')
            this.sourceNone = true
          } else {
            this.sourceNone = false
            arr.forEach(item => {
              this.custSourceList.push({ name: item.custSourceName, value: item.custSum, custSource: item.custSource })
            })
            this.drawChart2('4')
          }
        }
      })
    },
    // 所属地区区分
    async getStatisticsByCustArea() {
      this.custAreaList = []
      await statistics.getAreaData(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.custAreaList = []
            this.drawChart2('5')
            this.areaNone = true
          } else {
            this.areaNone = false
            arr.forEach(item => {
              this.custAreaList.push({ name: item.fullname, value: item.custSum, province: item.province })
            })
            this.drawChart2('5')
          }
        }
      })
    },
    // 单位性质区分
    async getStatisticsByCustUnitNature() {
      this.unitNatureList = []
      await statistics.getUnitNatureData(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.unitNatureList = []
            this.drawChart2('6')
            this.unitNone = true
          } else {
            this.unitNone = false
            arr.forEach(item => {
              this.unitNatureList.push({ name: item.dictLabel, value: item.custSum, unitNature: item.unitNature })
            })
            this.drawChart2('6')
          }
        }
      })
    },
    // 客户级别区分
    async getStatisticsByCustLevel() {
      this.custLevlList = []
      // if (this.options.crmCustLevelOptions.length == 0) {
      //   await getDicts('crm_cust_level').then(res => {
      //     this.options.crmCustLevelOptions = res.data
      //   })
      // }
      await statistics.getCustLevelData(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.custLevlList = []
            this.drawChart2('3')
          } else {
            arr.forEach(item => {
              this.custLevlList.push({ name: item.dictLabel, value: item.custSum, custLevel: item.custLevel })
            })
            this.drawChart2('3')
          }
          // this.options.crmCustLevelOptions.forEach(item => {
          //   if (!item.custSum) {
          //     item.custSum = 0
          //   }
          //   if (!arr) {
          //     this.custLevlList.push({ name: item.dictLabel, value: 0 })
          //   } else {
          //     arr.forEach(item2 => {
          //       if (item.dictLabel == item2.dictLabel) {
          //         item.custSum = item2.custSum
          //       }
          //     })
          //     this.custLevlList.push({ name: item.dictLabel, value: item.custSum })
          //   }
          // })
        }
      })
      // await this.drawChart2('3')
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    // 过滤子组件传递过来的搜索对象
    async handleFqueryFilter(data) {
      this.showFilterPop = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      if (this.queryParams.startTime || this.queryParams.endTime) {
        this.activeId = null
      } else {
        this.activeId = '1'
      }
      this.getStatistics()
      await this.getStatisticsByDept()

      await this.getStatisticsByCustIndustry()
      await this.getStatisticsByCustLevel()
      await this.getStatisticsByCustSource()
      await this.getStatisticsByCustArea()
      await this.getStatisticsByCustUnitNature()

      await this.getBusinessFunnel()
    },
    async clickTag(id) {
      this.activeId = id
      this.queryParams.dayType = id
      this.queryParams.startTime = null
      this.queryParams.endTime = null
      this.getStatistics()
      await this.getStatisticsByDept()

      await this.getStatisticsByCustIndustry()
      await this.getStatisticsByCustLevel()
      await this.getStatisticsByCustSource()
      await this.getStatisticsByCustArea()
      await this.getStatisticsByCustUnitNature()

      await this.getBusinessFunnel()
    },
    toDetail() {
      this.$router.push({
        path: '/tongji/details',
        query: {
          type: 'scrm',
          queryParams: JSON.stringify(this.queryParams)
        }
      })
    },
    drawChart() {
      var chartDom = document.getElementById('main')
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            var htmlStr = '<div style="width: auto;height: auto;max-height: 240px;overflow-y: auto;"><p>' + params[0].axisValue + '</p>'
            // for (var i = 0; i < params.length; i++) {
            // htmlStr += '<p style="color: #666;">' + params[0].marker + params[0].seriesName + ':' + params[0].value + '<span style="margin-left: 10px;">占比:' + (params[0].value / that.gridList.custSum.count * 100).toFixed(2) + '%</span>' + '</p>' +
            //         '<p style="color: #666;">' + params[1].marker + params[1].seriesName + ':' + params[1].value + '</p>' +
            //         '<p style="color: #666;">' + params[2].marker + params[2].seriesName + ':' + params[2].value + '</p>'
            // }
            for (var i = 0; i < params.length; i++) {
              htmlStr += '<p style="color: #666;">' + params[i].marker + params[i].seriesName + '：' + params[i].value + '</p>'
            }
            htmlStr += '<p style="color: #666;">' + params[0].marker + '客户数占比：' + (that.gridList.custSum.count == 0 ? 0 : (params[0].value / that.gridList.custSum.count * 100).toFixed(2)) + '%</p>'
            htmlStr += '</div>'
            return htmlStr
          }
        },
        legend: {
          data: ['客户数', '商机数', '成交数']
        },
        xAxis: [
          {
            type: 'category',
            data: that.divisionList, // ['科技', '创研云', '快人京东', '新媒体', '腾讯广告', '巨量', '创讯', '东巨', '点睛百度'],
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '客户数',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            data: that.custList
          },
          {
            name: '商机数',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: that.boList
          },
          {
            name: '成交数',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: that.boSuccessList
          }
        ]
      }
      option && myChart.setOption(option)
    },
    drawChart2(val) {
      var chartDom = document.getElementById('main' + val)
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      switch (val) {
        case '2':
          this.statisticsArr = this.custIndustryList
          break
        case '3':
          this.statisticsArr = this.custLevlList
          break
        case '4':
          this.statisticsArr = this.custSourceList
          break
        case '5':
          this.statisticsArr = this.custAreaList
          break
        case '6':
          this.statisticsArr = this.unitNatureList
          break
      }
      if (!this.statisticsArr || this.statisticsArr.length == 0) {
        chartDom.innerHTML = ('-暂无客户数据-')
        chartDom.style.cssText = 'text-align:center; color: #999; border: none;line-height: 300px;font-size: 18px'
        chartDom.removeAttribute('_echarts_instance_')
        return
      }
      option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>客户数量：{c}个<br/>占比：{d}%' // 鼠标放上去 展示内容
        },
        legend: {
          selectedMode: false, // 取消图例的点击事件
          orient: 'horizontal',
          // left: 'left'
          pageIconSize: 13,
          type: 'scroll'
        },
        series: [
          {
            top: val == '2' ? '50' : '',
            // name: '所属行业',
            type: 'pie',
            radius: '50%',
            data: that.statisticsArr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
      var clickTime = null
      var timeFn = null
      var onItemName = null
      // myDate.getMilliseconds();
      myChart.on('click', function (params) {
        var myDate = new Date()
        if (clickTime == null) {
          // 第一次进来
          clickTime = myDate.getMilliseconds()
          onItemName = params.name
          // 起一个定时器，进行重置
          timeFn = setTimeout(function() {
            // 要执行的代码
            clickTime = null
          }, 500)
        } else {
          clearTimeout(timeFn)
          // 第二次进来，
          if (Math.abs(myDate.getMilliseconds() - clickTime) < 500 && onItemName == params.name) {
            // 是双击操作
            // console.log(params)
            let query = that.queryParams
            if (params.data.industryCode) { query = { ...query, industryCode: params.data.industryCode } }
            if (params.data.custLevel) { query = { ...query, custLevel: params.data.custLevel } }
            if (params.data.custSource) { query = { ...query, custSource: params.data.custSource } }
            if (params.data.province) { query = { ...query, province: params.data.province } }
            if (params.data.unitNature) { query = { ...query, unitNature: params.data.unitNature } }
            that.$router.push({
              path: '/tongji/scrmList',
              query: {
                queryParams: JSON.stringify(query)
              }
            })
          }
          clickTime = null
        }
      })
    },
    drawChart7() {
      var chartDom = document.getElementById('main7')
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      if (!this.businessFunnel || this.businessFunnel.length == 0) {
        chartDom.innerHTML = ('-暂无商机相关数据-')
        chartDom.style.cssText = 'text-align:center; color: #999; border: none;line-height: 300px;font-size: 18px'
        chartDom.removeAttribute('_echarts_instance_')
        return
      }
      option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>商机数量：{c}个<br/>占比：{d}%' // 鼠标放上去 展示内容
        },
        legend: {
          // orient: 'vertical',
          // left: 'left'
        },
        series: [
          {
            // name: '商机数量',
            top: 30,
            type: 'pie',
            radius: '50%',
            data: that.businessFunnel,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)

      var clickTime = null
      var timeFn = null
      var onItemName = null
      // myDate.getMilliseconds();
      myChart.on('click', function (params) {
        var myDate = new Date()
        if (clickTime == null) {
          // 第一次进来
          clickTime = myDate.getMilliseconds()
          onItemName = params.name
          // 起一个定时器，进行重置
          timeFn = setTimeout(function() {
            // 要执行的代码
            clickTime = null
          }, 500)
        } else {
          clearTimeout(timeFn)
          // 第二次进来，
          if (Math.abs(myDate.getMilliseconds() - clickTime) < 500 && onItemName == params.name) {
            // 是双击操作
            // console.log(params)
            let query = that.queryParams
            if (params.data.boStageId) { query = { ...query, boStageId: params.data.boStageId } }
            that.$router.push({
              path: '/tongji/boList',
              query: {
                queryParams: JSON.stringify(query)
              }
            })
          }
          clickTime = null
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
// *{touch-action: none;}
.van-cell {
  touch-action: none;
}

/deep/.van-cell__value{
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 20px 0px;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}
/deep/.van-tabs{
  background-color: #fff;
}
/deep/.van-tabs__line{
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1.06667rem;
  height: 0.08rem;
  background-color: #1989fa;
  border-radius: 0.08rem;
}
/deep/.van-tab--active{
  color: #87CEFA;
}
/deep/.van-tab__text{
  font-size: 24px;
  font-weight: bold;
}

.sectionList {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .Statistics_num {
      font-size: 36px;
      font-weight: bold;
      color: #0000FF;
    }
    .Statistics_name{
      margin-top: 20px;
      font-size: 30px;
      color: #87CEFA;
      font-weight: bold;
    }
  }
  .percentage{
    font-size: 12px !important;
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
}
.Statistics_title{
  margin-top: 20px;
  background-color: #fff;
  padding: 10px 0;
  font-size: 28px;
  color:#87CEFA;
  text-align: center;
}
.none{
  background-color: #fff;
  margin-top: 10px;
  height: 660px;
}
.custSource{
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
  font-size: 16px;
  padding-bottom: 20px;
}
#main{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main2{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main3{
  width: 100%;
  height: 600px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main4{
  width: 100%;
  height: 560px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main5{
  width: 100%;
  height: 650px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main6{
  width: 100%;
  height: 600px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main7{
  width: 100%;
  height: 650px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 80px;
}
</style>
